import React from "react";
import styles from "./NextLevelLegalWording.scss";
import NextLevelImportantSafetyInformation from "components/common/ImportantSafetyInformation/NextLevelImportantSafetyInformation";

export default function NextLevelLeaderboardLegalWording(props) {

	return (
        <div className={styles.leaderBoardLegalWording}>
            <div className="padding-bottom-sm">The number of doses shown above are doses of <b>HEARTGARD® Plus</b> (ivermectin/pyrantel), <b><i>NexGard</i>®</b> (afoxolaner), <b><i>NexGard</i>® PLUS</b> (afoxolaner, moxidectin, and pyrantel chewable tablets), and <b><i>NexGard</i>® COMBO</b> (esafoxolaner, eprinomectin, and praziquantel topical solution) sold so far in this game.</div>
            <div className="padding-bottom-sm">To view current or previous doses broken out by product, click the underlined numbers in the leaderboard!</div>
            <div className="padding-bottom-sm">
                If you chose to run this game as a rolling comparison, the comparison is based off of doses dispensed (points earned) so far in this game versus doses dispensed (points earned) in the rolling sixty day timeframe of the previous sixty days in 2024 and 2025 of December, January, and February.
                If you chose to run this game as a year-over-year comparison, the comparison is based off of doses dispensed (points earned) so far in this game versus doses dispensed (points earned) in February, March, and April of 2024.
            </div>
            <div className="padding-bottom-sm">
                <a
                    className="text-primary"
                    href="https://cdn.greenlinepet.com/content/resources/Greenline_Games_Terms_And_Conditions_For_Backyard_Adventures.pdf"
                    target="_blank"
                >
                    View terms and conditions.
                </a>
            </div>
            <NextLevelImportantSafetyInformation />
            <div>
                <div className="padding-bottom-sm">
                    <b>HEARTGARD®</b>, is a registered trademark of Boehringer Ingelheim Animal Health USA Inc. <b><i>NexGard</i>®</b> is a registered trademark and <b><i>NexGard</i> COMBO™</b> is a trademark of Boehringer Ingelheim Animal Health France, used under license.
                </div>
                <div>
                    All other trademarks are the property of their respective owner. ©2025 Boehringer Ingelheim Animal Health USA Inc., Duluth, GA. All rights reserved. US-PET 0654-2025
                </div>
            </div>
        </div>
    )
}
